import { Component, OnInit, Input } from '@angular/core';
import { S1000FormComponent } from 'src/app/forms/s1000/s1000Form.component';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { S1040Component } from 'src/app/forms/s1040/s1040.component';
import { S1020Component } from 'src/app/forms/s1020/s1020.component';
import { S1005Component } from 'src/app/forms/s1005/s1005.component';
import { UtilServico } from 'src/app/servicos/util.servico';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';
import swal from 'sweetalert2';
import { menus } from '../sidemenu/menu-element';
//import { S1000Component } from 'src/app/paginas/s1000Screen/s1000.component';

@Component({
  selector: 'cdk-sidemenu-item',
  templateUrl: './sidemenu-item.component.html',
  styleUrls: ['./sidemenu-item.component.scss']
})
export class SidemenuItemComponent implements OnInit {
  @Input() menu;
  @Input() iconOnly: boolean;
  @Input() Pai: boolean;
  @Input() secondaryMenu = false;
  @Input() LinkAberto: string;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private utilServico: UtilServico,
    private utilDadosLogado: UtilDadosLogado
  ) {}

  ngOnInit() {
    this.Pai = false;
  }

  resetMenu(item) {
    for (let index = 0; index < item.length; index++) {
      if (item[index].sub != null) {
        for (let index2 = 0; index2 < item[index].sub.length; index2++) {
          item[index].sub[index2].ativo = false;
          if (item[index].sub[index2].sub != null) {
            for (let index3 = 0; index3 < item[index].sub[index2].sub.length; index3++) {
              item[index].sub[index2].sub[index3].ativo = false;
              if (item[index].sub[index2].sub[index3].sub != null) {
                for (let index4 = 0; index4 < item[index].sub[index2].sub[index3].sub.length; index4++) {
                  item[index].sub[index2].sub[index3].sub[index4].ativo = false;
                }
                this.resetMenu(item[index].sub[index2].sub[index3]);
              }
            }
            this.resetMenu(item[index].sub[index2]);
          }
        }
        this.resetMenu(item[index]);
      }
      item[index].ativo = false;
    }

    return item;
  }

  openLink(menu) {
    this.resetMenu(menus);
    menu.ativo = true;
    if (!menu.modal) {
      menu.open = !menu.open;
      if (menu.link) {
        this.router.navigate([menu.link]);
      }
    } else {
      if (menu.link === 'S100Component') {
        console.log(this.menu);
        let dialogRef = this.dialog.open(menu.link === '/s1000' ? S1000FormComponent : null, {
          width: '450px',
          hasBackdrop: true,
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {});
      } else if (menu.link === 'S1040Component') {
        let dialogRef = this.dialog.open(menu.link === 'S1040Component' ? S1040Component : null, {
          width: '450px',
          hasBackdrop: true,
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {});
      } else if (menu.link === 'S1020Component') {
        console.log('oi');
        let dialogRef = this.dialog.open(menu.link === 'S1020Component' ? S1020Component : null, {
          width: '450px',
          hasBackdrop: true,
          disableClose: true
        });
        /* let dialogRef = this.dialog.open(menu.link === 'S1020Component' ? S1020Component : null, {
           width: '450px',
           hasBackdrop: true,
           disableClose: true          
         });
   
         dialogRef.afterClosed().subscribe(result => {});*/
      } else if (menu.link === 'S1005Component') {
        console.log('aki');
        let dialogRef = this.dialog.open(menu.link === 'S1005Component' ? S1005Component : null, {
          width: '450px',
          hasBackdrop: true,
          disableClose: true
        });
      }else {
        const { db_config } = this.utilDadosLogado.DadosAcesso();
        this.Pai = false;
        this.utilServico
          .Post(
            'FuncaoCargosComissao/VerificarFolhaAtivos',
            {
              db_config
            },
            true
          )
          .subscribe(
            data => {
              if (data.utilizaFolhaAtivo === false) {
                swal.fire({
                  title: 'Atenção!',
                  type: 'warning',
                  text: 'O módulo Folha de Ativos não está habilitado no SISPREV WEB.'
                });
              } else {
              }
            },
            error => {
              swal.fire({
                title: 'Atenção!',
                type: 'error',
                text: error._body
              });
            }
          );
      }
    }
  }

  chechForChildMenu() {
    return this.menu && this.menu.sub ? true : false;
  }
}
